"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { createModal, showModal, escapeHtml } from "./shared_modal";
const SUMMARISE_ENDPOINT = "/api/summarise";
function fetchSummary(resourceType, resourceId) {
  return __async(this, null, function* () {
    var _a;
    const modal = createModal("Summary", "Generating summary...");
    showModal(modal);
    try {
      const response = yield fetch(SUMMARISE_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": ((_a = document.querySelector('meta[name="csrf-token"]')) == null ? void 0 : _a.content) || ""
        },
        body: JSON.stringify({
          resource_type: resourceType,
          resource_id: resourceId
        })
      });
      if (!response.ok) throw new Error(yield extractError(response));
      const data = yield response.json();
      renderSummary(modal, data);
    } catch (err) {
      const content = modal.querySelector(".analytics-modal__content");
      content.innerHTML = `<p class="analytics-modal__error">Failed to load summary: ${escapeHtml(err.message)}</p>`;
    }
  });
}
function extractError(response) {
  return __async(this, null, function* () {
    try {
      const data = yield response.json();
      if (data && data.error) {
        const extra = data.detail || data.source_response;
        return extra ? `${data.error}: ${extra}` : data.error;
      }
    } catch (e) {
    }
    return `HTTP ${response.status}`;
  });
}
function renderSummary(modal, data) {
  const titleEl = modal.querySelector(".analytics-modal__title");
  if (titleEl && data.title) titleEl.textContent = data.title;
  const sections = Array.isArray(data.sections) ? data.sections : [];
  const meta = [];
  if (data.comment_count != null) {
    meta.push(`${data.comment_count} comment${data.comment_count === 1 ? "" : "s"}`);
  }
  if (data.language) meta.push(String(data.language).toUpperCase());
  const content = modal.querySelector(".analytics-modal__content");
  content.innerHTML = `
    <div class="summarise-modal__summary">
      ${sections.map(
    (section) => `
        <section class="summarise-modal__section">
          <h3 class="summarise-modal__section-title">${escapeHtml(section.title || "")}</h3>
          <p>${escapeHtml(section.content || "")}</p>
        </section>`
  ).join("")}
      ${renderPointList("Discussion points", data.discussion_points, true)}
      ${renderPointList("Comment points", data.comment_points)}
      ${meta.length ? `<p class="summarise-modal__meta">${escapeHtml(meta.join(" \xB7 "))}</p>` : ""}
      ${renderDebugRequest(data.debug_request)}
    </div>
  `;
}
function renderDebugRequest(payload) {
  if (!payload) return "";
  return `
    <details class="summarise-modal__debug">
      <summary>Request sent to summarisation service (dev)</summary>
      <pre>${escapeHtml(JSON.stringify(payload, null, 2))}</pre>
    </details>`;
}
function renderPointList(title, points, ordered = false) {
  if (!Array.isArray(points) || !points.length) return "";
  const items = points.map((point) => `<li>${escapeHtml(String(point))}</li>`).join("");
  const tag = ordered ? "ol" : "ul";
  const listClass = ordered ? "summarise-modal__points summarise-modal__points--numbered" : "summarise-modal__points";
  return `
    <section class="summarise-modal__section">
      <h3 class="summarise-modal__section-title">${escapeHtml(title)}</h3>
      <${tag} class="${listClass}">${items}</${tag}>
    </section>`;
}
document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-summarise]");
  if (!btn) return;
  e.preventDefault();
  fetchSummary(btn.dataset.resourceType, btn.dataset.resourceId);
});
